












































import {
  CarpsaleHistoryManagementCarpsaleHistoryService,
  ChatManagementChatRecordDTO,
  ChatManagementService,
  StoreHistoryManagementOrderDTO,
} from "@/common/api";
import { formatImageUrl } from "@/common/utils";
import store from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CarpsaleHistoryChatPdfComponent",
  methods: { formatImageUrl },
  components: {
    //
  },
})
export default class CarpsaleHistoryChatPdfComponent extends Vue {
  public orderId: number = null;
  public records: ChatManagementChatRecordDTO[] = [];
  public order: StoreHistoryManagementOrderDTO = null;

  public mounted() {
    let base = document.createElement("link");
    base.setAttribute("rel", "stylesheet");
    base.setAttribute(
      "href",
      "https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.4.1/paper.css",
    );
    document.querySelector("head").append(base);

    base = document.createElement("link");
    base.setAttribute("rel", "stylesheet");
    base.setAttribute("href", "/css/pdf.css");
    document.querySelector("head").append(base);

    this.orderId = store.state.StoreHistory.orderId;
    this.getPrintData();
    this.getOrder();
  }

  public formatImageUrl(fileName) {
    return formatImageUrl(fileName, "x", "contain");
  }

  private async getPrintData() {
    const result = await ChatManagementService.adminChatList({
      order_id: this.orderId,
    });

    this.records = result.data.chat.chat_records;
  }

  private async getOrder() {
    const result = await CarpsaleHistoryManagementCarpsaleHistoryService.adminCarpsaleHistoryShow(
      {
        id: this.orderId,
      },
    );

    this.order = result.data.order;
  }
}
